/**
 * @file confirm.component.ts
 * @author Codeforce
 * @date 23 Mar 2020
 * @copyright 2020 Bisnode Deutschland GmbH
 * @brief functions/Variables for the frontend (confirm) component
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { RegisterService } from "../services/register.service";
import { VisitorsService } from "../services/visitors.service";
import { environment } from "../environments/environment";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-confirm",
  templateUrl: "./confirm.component.html",
})
export class ConfirmComponent implements OnInit {
  private countryCode = "de";
  newsletterImage = "";
  stickImage = "";
  amcLogoImage = "";
  fieldLabel;
  fieldLabel2;
  amcUnsubFormLabel: FormGroup;
  translateData = [];
  language = { key: ["de"] };
  token = "";
  res = "";
  ip = "";

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private route: ActivatedRoute
  ) {
    this.newsletterImage = environment.newsletterImage;
    this.stickImage = environment.stickImage;
    this.amcLogoImage = environment.amcLogoImage;
  }

  ngOnInit() {
    // get language param from route
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.countryCode = params.get("lang");
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.token = queryParams["token"];
    });

    if (this.countryCode == null) {
      this.countryCode = "de";
    }

    this.loadTranslateDataFromDB(this.countryCode);

    /**
     * Definition of form field-labels for frontend
     */

    this.amcUnsubFormLabel = this.formBuilder.group({
      nl_heading: ["AMC News"],
      nl_success_subscribed: [
        "Sie haben sich erfolgreich für die AMC News angemeldet.",
      ],
    });

    /**
     * set page initials
     */
    if (this.token != null) {
      /*this.visitorsService.getIpAddress()*/
      this.registerService.getIPAddress().subscribe(
        (res) => (this.ip = res["ip"]),
        (error) =>
          this.router.navigate(["./" + this.countryCode + "/error/error"]),
        () => {
          this.registerService.verifySubscriber(this.token, this.ip).subscribe(
            (result) => (this.res = result["response"]),
            (error) =>
              this.router.navigate(["./" + this.countryCode + "/error/error"]),
            () => {
              if (this.res != "success") {
                this.router.navigate([
                  "./" + this.countryCode + "/error/invalidlink",
                ]);
              }
            }
          );
        }
      );
    } else {
      this.router.navigate(["./" + this.countryCode + "/error/error"]);
    }
  }

  /**
   *
   * @param Label
   */
  getFieldLabel(Label) {
    this.fieldLabel2 = this.amcUnsubFormLabel.get(Label);
    return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
  }

  /**
   * Get translated data from the database from register.service.ts
   * @param language
   */
  loadTranslateDataFromDB(language) {
    this.translateData = [];
    this.language.key = language;
    this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
      (data) => {
        this.translateData = data;
        this.setTranslate();
      },
      (error) => {
        this.router.navigate(["./" + this.countryCode + "/error/error"]);
      }
    );
  }

  /**
   * Set labels with translated texts from the database
   */
  setTranslate() {
    this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcUnsubFormLabel.get(obj.key) != null
      ) {
        this.amcUnsubFormLabel.controls[obj.key].setValue(this.fieldLabel.text);
      }
    });
  }
}
